import React from 'react';
import { SidebarProvider, useSidebar } from '../../context/SidebarContext';
import { AppSidebar } from './AppSidebar';
import { AppHeader } from './AppHeader';

interface AppLayoutInnerProps {
  children: React.ReactNode;
}

const AppLayoutInner: React.FC<AppLayoutInnerProps> = ({ children }) => {
  const { isExpanded } = useSidebar();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <AppSidebar />
      <AppHeader />
      
      {/* Main Content */}
      <main
        className={`
          pt-16 transition-all duration-300
          ${isExpanded ? 'lg:ml-72' : 'lg:ml-20'}
        `}
      >
        <div className="p-4 lg:p-6">
          {children}
        </div>
      </main>
    </div>
  );
};

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <SidebarProvider>
      <AppLayoutInner>{children}</AppLayoutInner>
    </SidebarProvider>
  );
};
